import { connect } from 'react-redux';
import WireDataModal from "./WireDataModal";
import { getTranslation } from "../../../../../reducers/common/localization";
import { getActiveModal, hideModal, MODAL_BA_WIRE_DATA } from "../../../../../reducers/common/activeModal";

const mapStateToProps = state => {
    return {
        isOpen: getActiveModal(state).modalKey === MODAL_BA_WIRE_DATA,
        translation: getTranslation(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onCancel: () => {
            dispatch(hideModal());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WireDataModal);



// WEBPACK FOOTER //
// ./src/components/paymentManagement/systemPaymentComponent/duePaymentsList/wireDataModal/BAWireDataModal.container.js